import {Layout} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo} from 'react'
import {Switch} from 'react-router-dom'
import useToggle from 'react-use/lib/useToggle'
import {DelayRender} from 'views/Shared/components/DelayRender'
import {AiOutlineMenuFold, AiOutlineMenuUnfold} from "react-icons/ai";

export default function SettingsLayout({
                                           contextMenu,
                                           defaultToggle,
                                           routes,
                                           select,
                                           children,
                                           siderWidth,
                                       }) {
    const t = useTranslate()

    const [collapsed, toggle] = useToggle(defaultToggle)

    const location = useMemo(
        () => ({
            pathname: select,
        }),
        [select]
    )
    useEffect(() => {
        let isMounted = true
        if (isMounted) {
            toggle(true)
        }
        return () => {
            isMounted = false
        }
    }, [select])
    return (
        <Layout className="h-full 11-11">
            <Layout.Sider
                width={siderWidth}
                className="border-r"
                collapsed={collapsed && window.innerWidth <= 1024}
                collapsible
                trigger={null}
                collapsedWidth={0}>
                {contextMenu}
            </Layout.Sider>
            <main
                style={{
                    flex: 1,
                    minWidth: '300px',
                    flexShrink: 0,
                }}>
                <div style={{minHeight: 50}} className="flex items-center background z-10">
                    <div className="flex flex-center" style={{width: 40, height: 40}}>
                        {
                            collapsed ? (
                                <AiOutlineMenuUnfold onClick={toggle} size={20} className="text-color-300"/>
                            ) : (
                                <AiOutlineMenuFold onClick={toggle} size={20} className="text-color-300"/>
                            )
                        }
                    </div>
                    <span className="font-bold text-lg flex-1 capitalize">
            {t(select || '')}
          </span>
                </div>
                <DelayRender time={200}>
                    <div className="min-h-screen px-3 111-111">
                        {routes && <Switch location={location}>{routes}</Switch>}
                        {children}
                    </div>
                </DelayRender>
            </main>
        </Layout>
    )
}
